<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/history" class="active">History of LCCC</a></li>
                            <li><a routerLink="/museum" >Museum</a></li>
                            <li><a routerLink="/honours">Honours</a></li>
                            <li><a routerLink="/records">Records</a></li>
                            <li><a routerLink="/ground">Ground Devlopments</a></li>                                 
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="history-center-section cf">
        <div class="container">
            <div class="hostory-detail">
                <div class="titel-box">
                    <h2 class="titel-name">{{historyList?.data?.title}}</h2>
                </div>
                <div class="hostory-content" [innerHTML]="historyList?.data?.description">
                   
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->